
import { QueryClient, MutationCache } from '@tanstack/react-query';
import { toast } from "@/lib/toast";
import { apiErrorMessage } from '@/lib/messages';

function makeQueryClient() {
  return new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: (_data, _variables, _context, mutation) => {
        if (typeof mutation.options.onSuccess !== 'function') {
          toast.success('Operação concluída', {
            description: 'A alteração foi salva no sistema.',
          });
        }
      },
      onError: (error, _variables, _context, mutation) => {
        if (typeof mutation.options.onError !== 'function') {
          toast.error('A operação não foi concluída', {
            description: apiErrorMessage(error),
          });
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minuto
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (typeof window === 'undefined') {
    // Server: sempre criar novo client
    return makeQueryClient();
  }

  // Browser: reutilizar client existente
  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient();
  }
  return browserQueryClient;
}
